/* eslint-disable class-methods-use-this, no-unused-vars */

const { min, max } = Math;

const max_steps = 1000;

export default class DifferentialEquation {

	apply(boundary, dt, ...args) {
		throw new Error('Not implemented');
	}

}

class Evolver {

	max_dt = null;
	boundary = null;

	constructor(max_dt, boundary) {
		this.max_dt = max_dt;
		this.boundary = boundary;
	}

	apply(dt, ...fns) {
		const max_dt = max(dt / max_steps, this.max_dt);
		while (dt > 0) {
			const δt = min(max_dt, dt);
			dt -= δt;
			this.boundary();
			for (const [fn, ...args] of fns) {
				fn.apply(δt, ...args);
			}
		}
	}

}

DifferentialEquation.Evolver = Evolver;
